import Vue from 'vue'

const authorization = {
  state: {
    authorizeObj: null
  },
  mutations: {
    applyAuthorize: function (state, authorizeObj) {
      state.authorizeObj = authorizeObj
    },
    clearAuthorize: function (state) {
      state.authorizeObj = null
    }
  },
  actions: {
    // 加载用户授权信息
    loadUserAuthorize: function (context) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$ajax({
          url: '/index/homeIndex/authorizeData',
          method: 'post'
        }).then(response => {
          let resultObj = response['data']
          if (resultObj) {
            if (resultObj['responseCode'] === 'SUCCESS') {
              context.commit('applyAuthorize', resultObj['authorizeObj'])
              resolve()
            } else {
              context.commit('clearAuthorize')
              reject(new Error(resultObj['message'] || '未知类型错误'))
            }
          } else {
            context.commit('clearAuthorize')
            reject(new Error('返回登录信息为空'))
          }
        }, () => {
          context.commit('clearAuthorize')
          reject(new Error('用户登录请求发送失败'))
        })
      })
    },
    // 注销用户授权信息
    logoutRequest: function (context) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$ajax({
          url: '/logout',
          method: 'post'
        }).then(response => {
          context.commit('clearAuthorize')
          resolve()
        }, () => {
          reject(new Error('用户注销请求发送失败'))
        })
      })
    }
  }
}

export default authorization



// WEBPACK FOOTER //
// ./src/store/modules/authorization.js